import React from 'react'
import { Link } from 'react-router-dom'
import ArraivlSection from '../Components/ArraivlSection'
import Breadcrum from '../Components/Breadcrum'

const Shop = () => {
  return (
    <div>

      <Breadcrum pageName={"Shop"} />
      <ArraivlSection /> 
           
    </div>
  )
}

export default Shop
